import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChord = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 380 239",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		filter: "url(#filter0_dddd_8741_58)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M309.049 -70.6567C309.325 -68.0765 288.415 -64.2045 288.458 -61.6313C288.502 -59.0581 309.537 -55.8322 309.342 -53.2874C309.146 -50.7427 287.858 -50.6928 287.43 -48.1549C287.003 -45.617 307.163 -38.7642 306.519 -36.2605C305.874 -33.7569 284.887 -37.3188 284.063 -34.8824C283.239 -32.446 302.041 -22.4827 301.015 -20.1078C299.99 -17.7329 279.784 -24.4119 278.6 -22.11C277.417 -19.8082 294.639 -7.29845 293.313 -5.09695C291.988 -2.89545 272.814 -12.1819 271.357 -10.0377C269.901 -7.8935 285.427 6.64012 283.85 8.67822C282.273 10.7163 264.332 -0.770121 262.64 1.1834C260.942 3.11538 274.75 19.3326 272.958 21.1742C271.167 23.0158 254.558 9.69549 252.674 11.4468C250.789 13.198 262.835 30.7643 260.851 32.4037C258.867 34.0431 243.696 19.1141 241.641 20.6574C239.585 22.2007 249.811 40.9007 247.677 42.3263C245.544 43.7519 231.928 27.3909 229.744 28.7146C227.56 30.0383 235.926 49.6294 233.675 50.8785C231.425 52.1276 219.203 34.6779 216.908 35.8466C214.613 37.0154 221.576 57.1438 219.237 58.2322C216.898 59.3206 205.873 41.0882 203.495 42.1178C201.117 43.1474 206.864 63.6477 204.468 64.6127C202.073 65.5776 192.05 46.7769 189.637 47.6773C187.225 48.5776 191.981 69.3434 189.529 70.1849C187.105 71.0422 177.854 51.85 175.413 52.6427C172.977 53.4569 176.99 74.3757 174.515 75.1312C172.04 75.8866 163.369 56.4466 160.895 57.202C158.42 57.9575 161.969 78.9544 159.483 79.6667C157.002 80.4006 148.653 60.7822 146.167 61.4946C143.68 62.2069 147.008 83.24 144.522 83.9524C142.036 84.6647 133.773 65.0233 131.308 65.7298C128.843 66.4364 132.171 87.4695 129.685 88.1818C127.199 88.8942 118.812 69.3089 116.332 70.0428C113.851 70.7767 117.465 91.7563 115.017 92.5274C112.161 93.4082 102.511 74.2768 98.9728 75.4556C95.9829 76.4414 99.6526 97.5445 96.2824 98.7475C93.2294 99.8425 82.7115 81.1745 79.4505 82.4406C76.399 83.6275 81.0924 104.502 77.919 105.837C74.7457 107.172 63.3396 89.0654 60.2051 90.4592C57.1567 91.8299 63.1262 112.386 60.0909 113.892C57.0556 115.397 44.2965 98.1837 41.3389 99.807C38.3813 101.43 46.0231 121.423 43.1647 123.158C40.3063 124.893 25.83 109.109 23.1096 111.015C20.2932 112.993 30.3762 131.847 27.827 133.961C25.2778 136.075 8.39497 122.851 6.09304 125.199C3.64192 127.679 17.4827 143.933 15.553 146.55C13.4914 149.364 -6.36176 141.506 -7.75539 144.487C-9.14903 147.469 9.73416 157.133 9.14074 160.431C8.54732 163.729 -12.4751 166.407 -12.0818 169.856C-11.7147 173.035 9.45233 171.241 10.7415 174.588C11.8996 177.532 -5.32283 190.085 -3.37342 193.14",
			stroke: "#DBACF5",
			strokeWidth: 3.41073,
			strokeMiterlimit: 10
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_dddd_8741_58",
		x: -17.9498,
		y: -78.7167,
		width: 397.161,
		height: 316.831,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 3.325,
				dy: 1.6625
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.74063 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.05 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_8741_58"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 11.6375,
				dy: 5.81875
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 6.65 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.04 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect1_dropShadow_8741_58",
				result: "effect2_dropShadow_8741_58"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 26.6,
				dy: 13.3
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 8.72812 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.03 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect2_dropShadow_8741_58",
				result: "effect3_dropShadow_8741_58"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 47.3812,
				dy: 23.275
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10.3906 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.01 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect3_dropShadow_8741_58",
				result: "effect4_dropShadow_8741_58"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect4_dropShadow_8741_58",
				result: "shape"
			})
		]
	}) })]
});
export default SvgChord;
